import { useState, useEffect, useCallback } from 'react'
import { CollectionsQuery, PagesQuery } from './types'
import { GQL_ENDPOINT } from './consts'
import { loader } from 'graphql.macro'
import { GraphQLClient } from 'graphql-request'

const collectionsQuery = loader('../queries/collections.graphql')
const pagesQuery = loader('../queries/pages.graphql')

const client = new GraphQLClient(GQL_ENDPOINT)

export function useGraphData(): {
  collectionsData: CollectionsQuery | null
  pagesData: PagesQuery | null
  error: any
} {
  const [collectionsData, setCollectionsData] = useState(null)
  const [pagesData, setPagesData] = useState(null)
  const [error, setError] = useState()

  const fetchData = useCallback(() => {
    Promise.all([
      client.request(collectionsQuery),
      client.request(pagesQuery),
    ])
      .then(([collectionsResponse, pagesResponse]) => {
        setCollectionsData(collectionsResponse)
        setPagesData(pagesResponse)
      })
      .catch((err) => {
        setError(err)
        console.error('query error', err)
      })
  }, [])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return { collectionsData, pagesData, error }
}
